import { TdxService as GeneratedTdxService, callApi, configureApiClient } from "../api/client";
import { authUserData } from ".";

export type FlightSchedule = {
  ArrivalAirportID?: string;
  ArrivalTime?: string;
  DepartureAirportID?: string;
  DepartureTime?: string;
  Terminal?: string;
  Monday?: boolean;
  Tuesday?: boolean;
  Wednesday?: boolean;
  Thursday?: boolean;
  Friday?: boolean;
  Saturday?: boolean;
  Sunday?: boolean;
};

const configureTdxApiClient = () => {
  configureApiClient({
    tokenProvider: () => authUserData()?.jwtToken ?? null,
  });
};

export const getFlightSchedule = async (
  flightNo: string,
  checkDate: string
): Promise<FlightSchedule[] | null> => {
  const normalizedFlightNo = flightNo.trim().toUpperCase();
  const match = normalizedFlightNo.match(/^([A-Z0-9]{1,2})(\d{1,4})$/);
  if (!match) {
    return null;
  }

  try {
    configureTdxApiClient();
    const response = await callApi(
      () =>
        GeneratedTdxService.getApiTdxQueryFlightSchedule(
          match[1],
          match[2],
          checkDate,
          true
        ),
      "取得班機資訊失敗"
    );

    if (Array.isArray(response)) {
      return response as FlightSchedule[];
    }

    if (typeof response === "string") {
      const parsed = JSON.parse(response);
      return Array.isArray(parsed) ? (parsed as FlightSchedule[]) : null;
    }

    return null;
  } catch (error) {
    console.error("Error fetching flight schedule:", error);
    return null;
  }
};
